import { Svg } from './svg'

export const DomainIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8
      15C11.866 15 15 11.866 15 8ZM5.03038 9C5.10944 10.2896 5.33914 11.4658 5.67656
      12.4285C4.36867 11.7409 3.40266 10.4909 3.10002 9H5.03038ZM7.03464 9C7.12545 10.294
      7.38637 11.3905 7.71697 12.1619C7.8165 12.3941 7.91335 12.5759 8 12.7148C8.08665
      12.5759 8.1835 12.3941 8.28303 12.1619C8.61363 11.3905 8.87455 10.294 8.96536
      9H7.03464ZM8.96536 7H7.03464C7.12545 5.70597 7.38637 4.60948 7.71697 3.83809C7.8165
      3.60586 7.91335 3.4241 8 3.28516C8.08665 3.4241 8.1835 3.60586 8.28303 3.83809C8.61363
      4.60948 8.87455 5.70597 8.96536 7ZM10.9696 9C10.8906 10.2896 10.6609 11.4658 10.3234
      12.4285C11.6313 11.7409 12.5973 10.4909 12.9 9H10.9696ZM12.9 7C12.5973 5.5091 11.6313
      4.25909 10.3234 3.57148C10.6609 4.53416 10.8906 5.71038 10.9696 7H12.9ZM5.03038 7H3.10002C3.40266
      5.5091 4.36867 4.25909 5.67656 3.57148C5.33914 4.53416 5.10944 5.71038 5.03038 7Z"
    />
  </Svg>
)
